<app-header></app-header>

<div class="p-4">

  <!-- En-tête -->
  <div class="flex items-center gap-3 mb-5 pl-3 border-l-4 border-ag-red">
    <div>
      <h2 class="text-lg font-bold text-gray-900 m-0">Workflow de recrutement</h2>
      <p class="text-xs text-gray-400 m-0">Suivi et traitement des candidatures reçues</p>
    </div>
  </div>

  <!-- Carte tableau -->
  <div class="rounded-xl border border-gray-100 bg-white shadow-sm overflow-hidden">

    <!-- Barre d'outils -->
    <div class="flex flex-wrap items-center gap-2 px-4 py-3 border-b border-gray-100 bg-gray-50">
      <select [(ngModel)]="selectedOfferId" (change)="onOfferChange()"
              class="border border-gray-200 rounded-lg px-3 py-1.5 text-sm outline-none focus:border-ag-red w-72">
        <option [ngValue]="null">Toutes les offres</option>
        @for (o of offers; track o.id) { <option [ngValue]="o.id">{{o.title}}</option> }
      </select>
      <div class="ml-auto">
        <input type="text" [(ngModel)]="search_text" placeholder="Rechercher un candidat..."
               class="border border-gray-200 rounded-lg px-3 py-1.5 text-sm outline-none focus:border-ag-red focus:ring-2 focus:ring-ag-red/10 w-64">
      </div>
    </div>

    <app-loading [isVisible]="loading"></app-loading>

    <!-- Tableau -->
    <div class="overflow-x-auto">
      <table class="w-full text-sm">
        <thead>
          <tr class="bg-gray-50 text-start text-xs text-gray-400 uppercase tracking-wide">
            <th class="px-3 py-2">Candidat</th>
            <th class="px-3 py-2">Offre</th>
            <th class="px-3 py-2">Niveau</th>
            <th class="px-3 py-2 text-center">Expérience</th>
            <th class="px-3 py-2 text-center">Statut</th>
            <th class="px-3 py-2 text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (a of data | sampleSearch:search_text:'lastname' | paginate:{id:'wfPg', itemsPerPage:pg.pageSize, currentPage:pg.p, totalItems:pg.total}; track a.id) {
            <tr class="border-t border-gray-50 hover:bg-red-50/30 transition-colors">
              <td class="px-3 py-2 font-semibold text-gray-800">{{a.firstname}} {{a.lastname}}</td>
              <td class="px-3 py-2 text-gray-600">{{a.recruitment_offer?.title || a.offer?.title || '—'}}</td>
              <td class="px-3 py-2 text-gray-600">{{a.education_level || '—'}}</td>
              <td class="px-3 py-2 text-center text-gray-600">{{a.years_experience ?? 0}} an(s)</td>
              <td class="px-3 py-2 text-center">
                <span class="px-2 py-0.5 rounded-full text-xs font-semibold" [ngClass]="statusClass(a.status)">{{statusLabel(a.status)}}</span>
              </td>
              <td class="px-3 py-2 text-center">
                <div class="inline-flex items-center gap-1">
                  <button (click)="openDetail(a, detailContent)"
                          class="px-2.5 py-1 rounded-lg border border-ag-red text-ag-red hover:bg-ag-red hover:text-white text-xs transition-colors">
                    Détail
                  </button>
                  <button (click)="delete(a)"
                          class="px-2.5 py-1 rounded-lg border border-gray-300 text-gray-500 hover:bg-gray-100 text-xs transition-colors">
                    Suppr.
                  </button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    @if (!loading && data.length === 0) {
      <p class="text-center text-gray-400 py-8 text-sm">Aucune candidature.</p>
    }

    <div class="flex justify-center py-3">
      <pagination-controls id="wfPg" (pageChange)="getPage($event)"
                           [previousLabel]="'Précédent'" [nextLabel]="'Suivant'" [autoHide]="true">
      </pagination-controls>
    </div>
  </div>
</div>

<!-- Modal détail / workflow -->
<ng-template #detailContent let-c="close" let-d="dismiss">
  @if (selected) {
    <div class="flex items-center justify-between px-5 py-3 border-b border-gray-100 border-l-4 border-l-ag-red">
      <h5 class="font-bold text-gray-900 m-0">{{selected.firstname}} {{selected.lastname}}</h5>
      <button type="button" (click)="d('x')" class="w-7 h-7 rounded-full hover:bg-gray-100 text-gray-400">✕</button>
    </div>

    <div class="p-5 space-y-4">
      <!-- Statut actuel -->
      <div class="flex items-center gap-2">
        <span class="text-xs text-gray-400 uppercase">Statut actuel :</span>
        <span class="px-2 py-0.5 rounded-full text-xs font-semibold" [ngClass]="statusClass(selected.status)">{{statusLabel(selected.status)}}</span>
      </div>

      <!-- Infos candidat -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
        <div><span class="text-xs text-gray-400 uppercase block">Email</span> {{selected.email}}</div>
        <div><span class="text-xs text-gray-400 uppercase block">Téléphone</span> {{selected.phone || '—'}}</div>
        <div><span class="text-xs text-gray-400 uppercase block">Niveau d'études</span> {{selected.education_level || '—'}}</div>
        <div><span class="text-xs text-gray-400 uppercase block">Expérience</span> {{selected.years_experience ?? 0}} an(s)</div>
        <div class="md:col-span-2"><span class="text-xs text-gray-400 uppercase block">Offre</span> {{selected.recruitment_offer?.title || selected.offer?.title || '—'}}</div>
      </div>

      <!-- Lettre de motivation -->
      @if (selected.cover_letter) {
        <div>
          <span class="text-xs text-gray-400 uppercase block mb-1">Lettre de motivation</span>
          <p class="text-sm text-gray-700 bg-gray-50 rounded-lg p-3 whitespace-pre-line m-0">{{selected.cover_letter}}</p>
        </div>
      }

      <!-- CV -->
      @if (selected.cv_file) {
        <div>
          <a [href]="cvUrl(selected)" target="_blank"
             class="inline-flex items-center gap-1 px-3 py-1.5 rounded-lg border border-ag-red text-ag-red hover:bg-ag-red hover:text-white text-sm transition-colors">
            Voir / Télécharger le CV
          </a>
        </div>
      }

      <!-- Planification entretien -->
      <div class="rounded-lg border border-gray-100 p-3 bg-gray-50/50">
        <span class="text-xs text-gray-500 uppercase font-semibold block mb-2">Planification d'entretien</span>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
          <div>
            <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Date / heure</label>
            <input type="datetime-local" [(ngModel)]="interview.interview_date"
                   class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red">
          </div>
          <div>
            <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Lieu</label>
            <input type="text" [(ngModel)]="interview.interview_location" placeholder="Ex: Bureau direction"
                   class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red">
          </div>
          <div class="md:col-span-2">
            <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Notes</label>
            <textarea rows="2" [(ngModel)]="interview.notes"
                      class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red"></textarea>
          </div>
        </div>
      </div>
    </div>

    <!-- Actions workflow -->
    <div class="flex flex-wrap justify-end gap-2 px-5 py-3 border-t border-gray-100 bg-gray-50">
      @if (selected.status === 0) {
        <button (click)="setState(1)" class="px-3 py-2 rounded-lg bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold">Présélectionner</button>
      }
      @if (selected.status === 1) {
        <button (click)="planInterview()" class="px-3 py-2 rounded-lg bg-amber-500 hover:bg-amber-600 text-white text-sm font-semibold">Planifier entretien</button>
      }
      @if (selected.status === 2) {
        <button (click)="setState(3)" class="px-3 py-2 rounded-lg bg-green-600 hover:bg-green-700 text-white text-sm font-semibold">Retenir</button>
      }
      @if (selected.status === 3) {
        <button (click)="hire()" class="px-3 py-2 rounded-lg bg-ag-red hover:bg-ag-red-alt text-white text-sm font-semibold">Embaucher</button>
      }
      @if (selected.status !== 4 && selected.status !== 3) {
        <button (click)="setState(4)" class="px-3 py-2 rounded-lg border border-ag-red text-ag-red hover:bg-ag-red hover:text-white text-sm font-semibold">Rejeter</button>
      }
      <button type="button" (click)="d('x')" class="px-3 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100 text-sm">Fermer</button>
    </div>
  }
</ng-template>
